/* eslint-disable react/prop-types */
import React from 'react';
import useTabData from './useTabData';
import { TabLoading, TabError, TabEmpty } from './TabStates';
import { q } from './kit';

const STATE_LABEL = { active: 'Active', cancelled: 'Cancelled', on_hold: 'On hold', expired: 'Expired' };

const Row = ({ label, value }) => (
  <div className="ud-meta__row"><span className="k">{label}</span><span className="v">{value || '—'}</span></div>
);

// Subscription is lifecycle-based → NOT date-driven (no from/to).
const SubscriptionTab = ({ userId, authGet }) => {
  const { status, data, reload } = useTabData(async () => {
    const res = await authGet(`/admin/api/user-subscription-detail?${q(userId)}`);
    return res.data.data || { current: null, history: [] };
  }, [userId]);

  if (status === 'loading') return <TabLoading />;
  if (status === 'error') return <TabError onRetry={reload} />;

  const { current, history } = data;
  if (!current && (!history || history.length === 0)) {
    return <TabEmpty title="No subscription" message="This user has never subscribed." icon="＄" />;
  }

  return (
    <div className="ud-subgrid" data-testid="ud-subscription">
      <div className="au-panel">
        <div className="au-panel__head"><h4 className="au-panel__title">Current subscription</h4></div>
        <div style={{ padding: '14px 18px' }}>
          {current ? (
            <div className="ud-meta">
              <Row label="Plan" value={current.plan ? String(current.plan).replace(/_/g, ' ') : '—'} />
              <Row label="Store" value={current.store} />
              <Row label="State" value={STATE_LABEL[current.state] || current.state} />
              <Row label="Price" value={current.price} />
              <Row label="Auto-renew" value={current.auto_renewing === 'true' ? 'On' : current.auto_renewing === 'false' ? 'Off' : '—'} />
              <Row label="Started" value={current.start} />
              <Row label="Renews / expires" value={current.renew} />
              <Row label="Lifetime value" value={current.lifetime_value} />
            </div>
          ) : (
            <p className="ud-kpi__sub">No current subscription on record — see history.</p>
          )}
        </div>
      </div>

      <div className="au-panel">
        <div className="au-panel__head"><h4 className="au-panel__title">Subscription history</h4></div>
        <div style={{ padding: '16px 18px' }}>
          {history && history.length ? (
            <div className="ud-timeline" data-testid="ud-sub-timeline">
              {history.map((ev, i) => (
                <div className="ud-ev" key={`${ev.date}-${i}`}>
                  <div className="ud-ev__date">{ev.date}</div>
                  <div className="ud-ev__title">{ev.type_label}</div>
                  <div className="ud-ev__meta">
                    {[ev.amount, ev.store, ev.order_id].filter(Boolean).join(' · ') || '—'}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="ud-kpi__sub">No subscription events recorded.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionTab;
